import * as Sentry from "@sentry/react";
import { HydratedRouter } from "react-router/dom";
import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { ClientEnv } from "~/env";
import { disableIosTextFieldZoom, isIOS } from "~/lib/prevent-ios-auto-magnification";

declare global {
    interface Window {
        ENV: ClientEnv;
    }
}

// While we have every intention to make sure ENV exists, if it doesn't exist,
// the whole client app will be borked when we try to use it.
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
if (window.ENV) {
    Sentry.init({
        dsn: window.ENV.SENTRY_DSN,
        environment: window.ENV.APP_ENVIRONMENT,
    });
}

if (isIOS()) {
    disableIosTextFieldZoom();
}

startTransition(() => {
    hydrateRoot(
        document,
        <StrictMode>
            <HydratedRouter />
        </StrictMode>,
    );
});
